import {
  addItemToParent,
  adjustSectionHeights,
  findItemById,
  getValueByPath,
  removeItemById,
  setValueByPath,
  updateOnlyElementConfigInLayout
} from "../utils";

export function canDrop(draggedItem, targetItem) {
  if (!draggedItem || !targetItem) return false;

  if (targetItem.type === "tab" || targetItem.type === "element") return false;
  if (draggedItem.type === "section" && (targetItem.type === "section" || targetItem.type === "block")) return false;
  if (draggedItem.type === "full") return false;

  if (draggedItem.type === "column" && targetItem.type === "section") {
    const nestedSectionIds = draggedItem.children.flatMap((child) =>
      child.type === "section"
        ? [child.id, ...(child.children?.filter((c) => c.type === "section").map((c) => c.id) || [])]
        : []
    );
    if (nestedSectionIds.includes(targetItem.id)) return false;
  }
  if (draggedItem.type === "tab" && (targetItem.type === "full" || targetItem.type === "section")) {
    const nestedTabSectionIds = draggedItem.tabs.flatMap((tab) =>
      tab.children[0]
        ? [
            tab.children[0].id,
            ...(tab.children[0].children?.filter((c) => c.type === "section").map((c) => c.id) || [])
          ]
        : []
    );
    if (nestedTabSectionIds.includes(targetItem.id)) return false;
  }

  return true;
}

export function removeDraggedItemFromLayout(layoutConfig, draggedItem, otherInfo, setLayoutConfig) {
  if (!otherInfo || !otherInfo.path) {
    const newLayout = removeItemById(layoutConfig, draggedItem.id);
    setLayoutConfig(newLayout);
    return;
  }
  const mainElement = findItemById(layoutConfig, otherInfo.path[0]);
  if (mainElement.id === draggedItem.id) {
    const newLayout = removeItemById(layoutConfig, draggedItem.id);
    setLayoutConfig(newLayout);
    return;
  }
  const arrayElement = getValueByPath(mainElement, otherInfo.path[1]);
  const newArray = removeItemById(arrayElement, draggedItem.id);
  const updated = setValueByPath(mainElement, otherInfo.path[1], newArray);
  const finalLayout = updateOnlyElementConfigInLayout(layoutConfig, otherInfo.path[0], updated.config);
  setLayoutConfig(finalLayout);
}

export function calculateDropPosition(e, containerRect, dragOffset, correctionFactor, gridSize) {
  const dropX = snapToGrid(correctionFactor * (e.clientX - containerRect.left - dragOffset.x), gridSize);
  const dropY = snapToGrid(correctionFactor * (e.clientY - containerRect.top - dragOffset.y), gridSize);

  return { dropX, dropY, correctionFactor, containerRect };
}

export function snapToGrid(value, gridSize) {
  return Math.round(value / gridSize) * gridSize;
}

export function finalizeDrop(dropData, draggedItem, layoutConfig, setLayoutConfig) {
  const { parentId, dropX, dropY, otherInfo } = dropData;
  const updatedItem = {
    ...draggedItem,
    style: { ...draggedItem.style, left: `${dropX}px`, top: `${dropY}px` }
  };

  if (otherInfo && otherInfo.path) {
    const mainElement = findItemById(layoutConfig, otherInfo.path[0]);
    const arrayElement = getValueByPath(mainElement, otherInfo.path[1]);
    let newArray = addItemToParent(arrayElement, updatedItem, parentId);
    newArray = adjustSectionHeights(newArray);
    const config = setValueByPath(mainElement, otherInfo.path[1], newArray);
    const final = updateOnlyElementConfigInLayout(layoutConfig, otherInfo.path[0], config.config);
    setLayoutConfig(final);
  } else {
    let newLayout = addItemToParent(layoutConfig, updatedItem, parentId);
    newLayout = adjustSectionHeights(newLayout);
    setLayoutConfig(newLayout);
  }
}
